<template>
  <div v-if="reservationSteps.length > 0" class="md:pt-2">
    <ol class="reservation-wizard flex justify-between">
      <li
        v-for="reservationStep in reservationSteps"
        :key="reservationStep.label"
        class="reservation-wizard__list before:border-gray1 before:[&:nth-child(n+1)]:border-t-[1px]"
        :class="{
          'before:!border-gold1 before:[&:nth-child(n+1)]:border-t-[1px]': reservationStep.active || reservationStep.done,
          'reservation-wizard__list--done': reservationStep.done,
          'reservation-wizard__list--active': reservationStep.active,
        }"
      >
        <p class="m-auto max-w-[50px] pt-3 text-xs leading-4 tracking-[0.5px]">
          <template v-if="reservationStep.link">
            <nuxt-link :to="reservationStep.link">{{ reservationStep.label }}</nuxt-link>
          </template>
          <template v-else>
            {{ reservationStep.label }}
          </template>
        </p>
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import type { WabunkaExperienceEventReservationType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event_reservation_type';

import { stepsBuilder, type ReservationStepLabels } from '.';

interface Props {
  currentReservationStepLabel: ReservationStepLabels;
  reservationType?: WabunkaExperienceEventReservationType;
}

const props = defineProps<Props>();

const reservationSteps = stepsBuilder(props.currentReservationStepLabel, props.reservationType);
</script>

<style scoped lang="scss">
.reservation-wizard {
  &__ {
    &list {
      width: 100%;
      position: relative;
      text-align: center;

      &:nth-of-type(n + 1)::before {
        content: '';
        display: block;
        width: 100%;
        position: absolute;
        top: 0;
        left: -50%;
      }

      &::after {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        position: absolute;
        top: -8px;
        left: calc(50% - 8px);
        background-image: url('@/assets/img/parts/progress-bar-sleep.svg');
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 1;
      }
    }
  }
}

.reservation-wizard__list:first-child::before {
  width: 50%;
  left: 0;
}

.reservation-wizard__list--active {
  &::after {
    background-image: url('@/assets/img/parts/progress-bar-active.svg');
  }
}
.reservation-wizard__list--done {
  &::after {
    background-image: url('@/assets/img/parts/progress-bar-done.svg');
  }
}
</style>
